import {Directive, Input}                  from '@angular/core';
import {_MatMenuTriggerBase, MatMenuPanel} from '@angular/material/menu';

@Directive({
    selector: `[ngxMatMenuTriggerFor]`,
    exportAs: 'ngxMatMenuTrigger',
    standalone: true
})
export class PopoverDirective extends _MatMenuTriggerBase
{
    override _handleClick(event: MouseEvent): void
    {
        // Nothing to do
    }

    @Input('ngxMatMenuTriggerFor')
    override get menu(): MatMenuPanel
    {
        return super.menu;
    }

    override set menu(menu: MatMenuPanel)
    {
        super.menu = menu;
    }
}